export const fileAdded = (fileName: string, nodeRef: string) => ({
  fileName,
  nodeRef,
  page: 'document-details',
  site: window.Alfresco.constants.SITE,
  type: 'file-added',
});

export const filesAdded = (count: number, parent: string) => ({
  fileCount: count,
  page: 'documentlibrary',
  parentNodeRef: parent,
  path: window.location.hash === '' ? '/' : window.location.hash.replace('#', ''),
  site: window.Alfresco.constants.SITE,
  type: 'files-added',
});

export const fileUpdated = (fileName: string, nodeRef: string, site: string = window.Alfresco.constants.SITE) => ({
  fileName,
  nodeRef,
  page: 'document-details',
  site,
  type: 'file-updated',
});
